function GetTranslateableResource(resource) {
    if (!resource) return "";
    return resource.ResourceValue;
}
